import { createComponent } from 'react-fela'

export const ChipWrapper = createComponent(() => ({
	background: '#3E6EEA',
	borderRadius: '4px',
	display: 'flex',
	justifyContent: 'space-between',
	maxWidth: '173px',
	minHeight: '54px',
	marginTop: '10px',
	marginRight: '12px',
	minWidth: '132px',
}))

export const TextPlaceholder = createComponent(() => ({
	padding: 12,
	color: 'white',
	width: '90%',
	fontSize: '12px',
	lineHeight: '16px',
	height: '32px',
	boxSizing: 'content-box',
	position: 'relative',
	overFlow: 'hidden',
	'&:after': {
		textAlign: 'right',
		height: '12px',
		bottom: 0,
		right: 0,
		position: 'absolute',
		background: '#3E6EEA',
		content: 'close-quote',
		width: '100%',
	},
	'&:before': {
		bottom: 0,
		right: 0,
		position: 'absolute',
	},
}))

export const CancelIconDiv = createComponent(() => ({
	height: '17.5px',
	width: '17.5px',
	marginTop: '-10px',
	marginRight: '-5px',
}))
